import { redirect } from 'react-router-dom'
import { match } from 'ts-pattern'
import { UserPreferencesPort } from '@/domains/user-preference/UserPreferencePort'

export const runUserPreferencesGuard = (
  userPreferences: UserPreferencesPort,
  currentPath: string
) => {
  const hasLanguage = Boolean(userPreferences.getLanguageId())
  const hasStore = Boolean(userPreferences.getStore())
  const hasTeam = Boolean(userPreferences.getTeam())
  const isConfigured = userPreferences.isConfigured()

  return match({ currentPath, hasLanguage, hasStore, isConfigured, hasTeam })
    .with({ isConfigured: true }, () => null)
    .with({ hasLanguage: false }, () => redirect('/select-lang'))
    .with({ currentPath: '/select-store' }, () => null)
    .with({ hasStore: false }, () => redirect('/select-store'))
    .with({ currentPath: '/select-team' }, () => null)
    .with({ hasTeam: false }, () => redirect('/select-team'))
    .otherwise(() => null)
}
